import { IconBrandTelegram, IconBrandVk, IconBrandWhatsapp, IconMessage2 } from '@tabler/icons-react';
import { CVETA_MESSENDZHEROV } from '../cvetaMessendzherov';

/**
 * ⛔ КРУГ СЛЕВА = МЕССЕНДЖЕР В СВОЁМ ЦВЕТЕ НА ЗАЛИВКЕ ФИЛИАЛА. ОДНО МЕСТО НА ВСЮ ВЕТКУ.
 *
 * Решение владельца (15.09, дословно): «аватарок пользователей практически в
 * системе нет, они бессмысленны, лучше использовать это место как раз для
 * обозначения мессенджера филиала». Один круг отвечает дежурному сразу на два
 * вопроса — из какого мессенджера читаем и чей это филиал.
 *
 * ⛔ ПРАВКА `s604` (владелец, п.1: «иконки слева — оформить в соответствии с
 * цветом и стилем мессенджера, как в примере»). `s603` красила ВЕСЬ круг цветом
 * филиала, а значок делала белым — мессенджер узнавался по форме, но не по
 * цвету, и три круга подряд читались как три пятна одного филиала.
 *
 * Теперь цвета разведены по ролям, и роли не спорят:
 *   — глиф несёт ФИРМЕННЫЙ цвет мессенджера (его и узнают с полувзгляда);
 *   — фон БЕЛЫЙ;
 *   — кольцо — цвет филиала в полную силу.
 * Мессенджер читается формой и цветом, филиал — кольцом. Каждый цвет отвечает
 * ровно за одно.
 *
 * ⛔ ЗАЛИВКИ НЕТ (владелец, 15.09: «убери эту дибильную заливку… просто белый
 * где лого мессенджера»). Светлая заливка цвета филиала глушила фирменный цвет
 * мессенджера: два цвета в одном круге спорили, и узнавались оба хуже, чем
 * каждый по отдельности.
 *
 * ⛔ У MAX БРЕНДОВОГО ЗНАЧКА НЕТ НИ В ОДНОМ НАБОРЕ — ставим его имя буквами,
 * ровно как в ратифицированном макете. Выдуманный значок узнавался бы хуже слова.
 */

/**
 * Фирменные цвета мессенджеров — с их же бренд-страниц.
 *
 * ⛔ ОДНА КАРТА НА ВЕТКУ. Впиши зелёный WhatsApp по месту — и завтра рядом
 * появится второй зелёный, чуть другой, а «почему они разные» ответить будет
 * нечем.
 */


/** Цвет незнакомого канала — серый: он показывает СЕБЯ, а не притворяется чужим. */
const CVET_NEZNAKOMOGO = '#64748B';

export interface ZnachokProps {
  kind: string;
  color: string;
  /** Размер круга в точках: 44 в списке, 36 в шапке раскрытия, 24 в баре. */
  razmer?: number;
  title?: string;
}

export function ZnachokKanala({ kind, color, razmer = 44, title }: ZnachokProps) {
  const glif = razmer * 0.52;
  const cvetGlifa = CVETA_MESSENDZHEROV[kind] ?? CVET_NEZNAKOMOGO;
  // Кольцо тоньше на мелких размерах: полтора пикселя на круге в 24 точки
  // съели бы четверть заливки, и филиал перестал бы читаться.
  const kolco = razmer >= 36 ? 2 : 1.5;

  return (
    <span
      title={title}
      aria-label={title}
      className="flex shrink-0 items-center justify-center rounded-full"
      style={{
        width: razmer,
        height: razmer,
        // ⛔ ФОН БЕЛЫЙ, БЕЗ ЗАЛИВКИ (владелец, 15.09: «убери эту дибильную
        // заливку… просто белый где лого мессенджера»). Заливка цвета филиала
        // глушила фирменный цвет мессенджера — узнавались оба хуже, чем каждый
        // по отдельности. Филиал теперь несёт ТОЛЬКО кольцо, и несёт один.
        backgroundColor: '#FFFFFF',
        border: `${kolco}px solid ${color}`,
        color: cvetGlifa,
      }}
    >
      <Glif kind={kind} razmer={glif} />
    </span>
  );
}

export function Glif({ kind, razmer }: { kind: string; razmer: number }) {
  if (kind === 'whatsapp') return <IconBrandWhatsapp size={razmer} stroke={2} />;
  if (kind === 'telegram') return <IconBrandTelegram size={razmer} stroke={2} />;
  if (kind === 'vk') return <IconBrandVk size={razmer} stroke={2} />;
  if (kind === 'max') {
    return (
      <span className="font-bold leading-none" style={{ fontSize: Math.round(razmer * 0.6) }}>
        MAX
      </span>
    );
  }

  // Незнакомый канал показывает СЕБЯ значком «сообщение», а не пустотой:
  // пустой круг читался бы как поломка (закон `s204`).
  return <IconMessage2 size={razmer} stroke={2} />;
}

